"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableRowPager = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useDataTreeActions_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTreeActions"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useSelectionActions_1 = __importDefault(require("@opsbase/web-data-selection/useSelectionActions"));
const DoubleChevronLeftIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DoubleChevronLeftIcon"));
const DoubleChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DoubleChevronRightIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    dots: { marginRight: 16, marginBottom: 16 },
    label: {
        marginLeft: 4,
        marginRight: 4,
        whiteSpace: 'noWrap',
    },
    pageButtons: {
        minWidth: 40,
    },
});
function DVLTableRowPager(props) {
    const { nodeKey, oneLine = false } = props;
    const dt = (0, useDataTree_1.default)();
    const node = dt.nodesByKey.get(nodeKey);
    const { type: dataType } = (0, useView_1.default)(dt.viewId);
    const { changeNodePage } = (0, useDataTreeActions_1.default)();
    const { clearSelection } = (0, useSelectionActions_1.default)(dataType);
    const itemCollection = node.itemCollection;
    const items = (itemCollection === null || itemCollection === void 0 ? void 0 : itemCollection.items) || [];
    const count = items.length;
    const totalCount = (itemCollection === null || itemCollection === void 0 ? void 0 : itemCollection.totalCount) || 0;
    const isLoading = itemCollection ? itemCollection.loading : true;
    const page = node.page;
    const offset = page * dt.pageSize;
    const showPrev = offset > 0;
    const showNext = offset + dt.pageSize < totalCount;
    const prevIconColor = showPrev ? lib_palette_1.default.GreyBlue : lib_palette_1.default.White;
    const nextIconColor = showNext ? lib_palette_1.default.GreyBlue : lib_palette_1.default.White;
    const hasMore = count < totalCount;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const title = hasMore ? `Records ${offset + 1} to ${offset + count} of ${totalCount}` : '';
    const onClickPrevPage = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        clearSelection();
        changeNodePage(node, -1);
    }, [changeNodePage, clearSelection, node]);
    const onClickNextPage = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        clearSelection();
        changeNodePage(node, 1);
    }, [changeNodePage, clearSelection, node]);
    return (0, react_1.useMemo)(() => {
        const dots = isLoading && react_1.default.createElement(Dots_1.default, { color: lib_palette_1.default.LavendarGrey, className: myCss.dots });
        const prevIcon = !isLoading && showPrev && (react_1.default.createElement(IconButton_1.default, { noOpacity: true, size: 20, icon: react_1.default.createElement(DoubleChevronLeftIcon_1.default, { color: prevIconColor }), onClick: onClickPrevPage }));
        const nextIcon = !isLoading && showNext && (react_1.default.createElement(IconButton_1.default, { noOpacity: true, size: 20, icon: react_1.default.createElement(DoubleChevronRightIcon_1.default, { color: nextIconColor }), onClick: onClickNextPage }));
        const text = !isLoading && (react_1.default.createElement(Text_1.default, { variant: "small", color: "grey", className: myCss.label }, title));
        return oneLine ? (react_1.default.createElement(Horizontal_1.default, { centered: true, justify: "center" },
            dots,
            prevIcon,
            text,
            nextIcon)) : (react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Horizontal_1.default, { justify: "flex-end" },
                dots,
                prevIcon,
                nextIcon),
            text));
    }, [
        oneLine,
        myCss,
        isLoading,
        showPrev,
        prevIconColor,
        onClickPrevPage,
        title,
        showNext,
        nextIconColor,
        onClickNextPage,
    ]);
}
exports.DVLTableRowPager = DVLTableRowPager;
exports.default = DVLTableRowPager;
